import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { ErrorMessage, RequiredMark } from "@components/inputs/shared";
import { CheckboxFieldProps } from "../types";

export default function CheckboxField(props: CheckboxFieldProps) {
	const { t } = useTranslation();
	const { register } = useFormContext();
	const {
		label = "",
		name,
		checkboxClassname = "input--check",
		id,
		errorMessage,
		required = false,
		customLabel,
		labelClassName = "input--check__label",
		asterisksClass,
		...rest
	} = props;

	const field = register(name, {
		required: {
			value: required,
			message: errorMessage || "COMMON.REQUIRED_FIELD",
		},
		disabled: props.disabled,
	});

	return (
		<div className={checkboxClassname}>
			<ErrorMessage name={name} addClassName="input--check__validation" />

			<input
				id={id}
				className="input--check__box"
				type="checkbox"
				{...rest}
				{...field}
			/>
			<label htmlFor={id} className={classNames(labelClassName)}>
				{customLabel ? (
					<>
						{customLabel}
						<RequiredMark
							required={required}
							asterisksClass={asterisksClass}
						/>
					</>
				) : (
					<span>
						{t(label)}{" "}
						<RequiredMark
							required={required}
							asterisksClass={asterisksClass}
						/>
					</span>
				)}
			</label>
		</div>
	);
}
